import React from "react";
import {Checkbox, FormControlLabel} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import Call from "../../../hocs/call";
import {appConfigDateFormatSelector} from "../../../state/app-config/appConfigSelectors";
import {fetchAppLicense} from "../../../state/miscellaneous/miscellaneousActions";
import {licenseSelector} from "../../../state/miscellaneous/miscellaneousSelectors";

const LicenseForm = () => {
  const {t, i18n} = useTranslation();
  const dispatch = useDispatch();

  const dateFormat = useSelector(appConfigDateFormatSelector);
  const license = useSelector(licenseSelector);

  return (
    <Call cb={() => dispatch(fetchAppLicense())} disabled={license !== null}>
      <Grid container rowSpacing={3} className="license-form" sx={{paddingTop: "8px"}}>
        <Grid size={12}>
          <TextField
            fullWidth
            label={t("components.licenseForm.licenseId")}
            value={license?.licenseId || ""}
            slotProps={{input: {readOnly: true}}}
            variant="outlined"
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            label={t("components.licenseForm.issuer")}
            value={license?.issuer || ""}
            slotProps={{input: {readOnly: true}}}
            variant="outlined"
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            label={t("components.licenseForm.user")}
            value={license?.user || ""}
            slotProps={{input: {readOnly: true}}}
            variant="outlined"
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            label={t("components.licenseForm.version")}
            value={license?.version || ""}
            slotProps={{input: {readOnly: true}}}
            variant="outlined"
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            label={t("components.licenseForm.expiration")}
            value={license?.expiration ? moment(license.expiration).format(dateFormat) : ""}
            slotProps={{input: {readOnly: true}}}
            variant="outlined"
          />
        </Grid>
        {Object.keys(license?.features?.booleans || {}).length > 0 && (
          <Grid container>
            <Grid size={12} sx={{mb: "8px"}}>
              {t("components.licenseForm.enabledModules")}:
            </Grid>
            {Object.keys(license?.features?.booleans || {}).map(feature => (
              <Grid key={feature} size={12}>
                <FormControlLabel
                  label={
                    i18n.exists(`components.licenseForm.features.${feature}`)
                      ? t(`components.licenseForm.features.${feature}`)
                      : feature
                  }
                  control={<Checkbox checked={license.features.booleans[feature] === "True"} />}
                  disabled
                />
              </Grid>
            ))}
          </Grid>
        )}
        {Object.keys(license?.features?.others || {}).length > 0 && (
          <Grid item container>
            {Object.keys(license?.features?.others || {}).map(feature => (
              <Grid key={feature} item xs={12}>
                {`${i18n.exists(`components.licenseForm.features.${feature}`) ? t(`components.licenseForm.features.${feature}`) : feature}: ${license.features.others[feature]}`}
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Call>
  );
};

export default LicenseForm;
